import { render } from "./SettingsModal.vue?vue&type=template&id=5b6ab68e"
import script from "./SettingsModal.vue?vue&type=script&lang=js"
export * from "./SettingsModal.vue?vue&type=script&lang=js"

import "./SettingsModal.vue?vue&type=style&index=0&id=5b6ab68e&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__